// Zentrale Navigations-Definition — von Sidebar UND „Menü anpassen"-Seite genutzt.
import {
  House, Users, CalendarBlank, DoorOpen, Receipt, ChartLine,
  Kanban, PaperPlaneTilt, Robot, Gear, Star, CheckSquare, Sparkle, Notebook, QrCode, Clock, List, CurrencyEur, Scales, Envelope, ChatCircleDots, ShieldCheck, ForkKnife, Tag,
} from "@phosphor-icons/react";

export const NAV_ITEMS = [
  { to: "/",              label: "Dashboard",           icon: House,          roles: ["admin", "staff"], end: true },
  { to: "/buchungen",     label: "Buchungen",           icon: CalendarBlank,  roles: ["admin", "staff"] },
  { to: "/posteingang",   label: "E-Mail-Posteingang",  icon: Envelope,       roles: ["admin"], badge: "email" },
  { to: "/inbox",         label: "WhatsApp-Inbox",      icon: ChatCircleDots, roles: ["admin"], badge: "whatsapp" },
  { to: "/gaeste",        label: "Gäste",               icon: Users,          roles: ["admin", "staff"] },
  { to: "/zimmer",        label: "Zimmer",              icon: DoorOpen,       roles: ["admin", "staff"] },
  { to: "/raten",         label: "Raten & Verfügbarkeit", icon: Tag,          roles: ["admin"] },
  { to: "/rechnungen",    label: "Rechnungen",          icon: Receipt,        roles: ["admin"] },
  { to: "/ausgaben",      label: "Ausgaben",            icon: CurrencyEur,    roles: ["admin"] },
  { to: "/statistik",     label: "Umsatz & Statistik",  icon: ChartLine,      roles: ["admin"] },
  { to: "/monatsjournal", label: "Monats-Journal",      icon: Notebook,       roles: ["admin"] },
  { to: "/insights",      label: "Wachstums-Zentrale",  icon: Sparkle,        roles: ["admin"] },
  { to: "/aufgaben",      label: "Aufgaben",            icon: Kanban,         roles: ["admin", "staff"] },
  { to: "/schichtplan",   label: "Schichtplan",         icon: Clock,          roles: ["admin", "staff"] },
  { to: "/nachrichten",   label: "Nachrichten",         icon: PaperPlaneTilt, roles: ["admin"] },
  { to: "/freigaben",     label: "Freigaben",           icon: CheckSquare,    roles: ["admin"] },
  { to: "/bewertungen",   label: "Bewertungen",         icon: Star,           roles: ["admin", "staff"] },
  { to: "/formulare",     label: "Formulare · QR",      icon: QrCode,         roles: ["admin", "staff"] },
  { to: "/anfragen",      label: "Anfragen",            icon: Envelope,       roles: ["admin"] },
  { to: "/nic",           label: "NIC Assistent",       icon: Robot,          roles: ["admin", "staff"] },
  { to: "/steuerberater-verwaltung", label: "Steuerberater", icon: Scales,   roles: ["admin"] },
  { to: "/datensicherung", label: "Datensicherung",     icon: ShieldCheck,   roles: ["admin"] },
  { to: "/speisekarte",   label: "Speisekarte",         icon: ForkKnife,      roles: ["admin"] },
  { to: "/menu-anpassen", label: "Menü anpassen",       icon: List,           roles: ["admin"] },
  { to: "/einstellungen", label: "Einstellungen",       icon: Gear,           roles: ["admin"] },
];

/** Wendet gespeicherte Reihenfolge (Array of `to`-Pfade) auf NAV_ITEMS an. Fehlende Einträge kommen ans Ende. */
export function applyMenuOrder(items, order) {
  if (!order || !order.length) return items;
  const map = new Map(items.map((i) => [i.to, i]));
  const ordered = [];
  for (const key of order) {
    if (map.has(key)) { ordered.push(map.get(key)); map.delete(key); }
  }
  return [...ordered, ...map.values()];
}
